import { memo } from "react";

import Note from "../../../../../public/assets/icon/sns/note.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const NoteIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Note });
	return <Icon />;
};

export default memo(NoteIcon);
